import Axios from "axios";

export const SelectTopclient = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FACCLIs?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "TOP_SELECT", payload: response.data });
    });
  };
};
